export default "{\n    \"emptyPlaceholder\": \"Seleccionar un tipo\",\n    \"searchPlaceholder\": \"Buscar tipos\"\n}\n"